module.exports = __webpack_public_path__ + "static/img/10001 (6).d2b205b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (6).webp
// module id = pI4i
// module chunks = 14